import { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import API_BASE from "../../config";
import { pick } from "../sitecontent/siteContent";
import PublicUserBadge from "../../components/PublicUserBadge";
import Markdown from "../../components/Markdown";
import s from "./ProgramPage.module.css";

const SLUGS = {
  preschool: { imageKey: "preschool", keyBase: "programs.preschool" },
  grade:     { imageKey: "grade",     keyBase: "programs.grade"     },
  junior:    { imageKey: "junior",    keyBase: "programs.junior"    },
  senior:    { imageKey: "senior",    keyBase: "programs.senior"    },
};

export default function ProgramPage() {
  const { slug } = useParams();
  const meta = SLUGS[slug];

  const [content, setContent] = useState({});
  const [images,  setImages]  = useState({});

  useEffect(() => {
    fetch(`${API_BASE}/api/site-content`)
      .then(r => (r.ok ? r.json() : {}))
      .then(obj => setContent(obj || {}))
      .catch(() => setContent({}));
    fetch(`${API_BASE}/api/program-images`)
      .then(r => (r.ok ? r.json() : {}))
      .then(obj => setImages(obj || {}))
      .catch(() => setImages({}));
  }, []);

  if (!meta) return <Navigate to="/" replace />;

  const title   = pick(content, meta.keyBase);
  const tagline = pick(content, `${meta.keyBase}.tagline`);
  const body    = pick(content, `${meta.keyBase}.body`);
  const photo   = images[meta.imageKey];

  return (
    <div className={s.page}>
      {/* ── Top bar ── */}
      <header className={s.topbar}>
        <Link to="/" className={s.brand}>
          <img src="/ncla-logo.png" alt="NCLA logo" className={s.brandDot} />
          NCLA
        </Link>
        <div className={s.topActions}>
          <Link to="/#programs" className={s.backBtn}>← All programs</Link>
          <Link to="/" className={s.homeBtn}>Home</Link>
          <PublicUserBadge variant="dark" compact />
        </div>
      </header>

      {/* ── Hero ── */}
      <section className={s.hero} style={photo ? { backgroundImage: `url(${photo})` } : undefined}>
        <div className={s.heroOverlay} />
        <div className={s.heroInner}>
          <span className={s.heroEyebrow}>NCLA Program</span>
          <h1 className={s.heroTitle}>{title}</h1>
          {tagline && <p className={s.heroSub}>{tagline}</p>}
        </div>
      </section>

      {/* ── Body ── */}
      <article className={s.article}>
        {body ? (
          <Markdown text={body} className={s.body} />
        ) : (
          <div className={s.empty}>
            Full program details coming soon. Please{" "}
            <Link to="/#contact" className={s.inlineLink}>contact us</Link>{" "}
            to learn more about our {title} offering.
          </div>
        )}

        <div className={s.footer}>
          <Link to="/#contact" className={s.ctaBtn}>Contact admissions</Link>
          <Link to="/#programs" className={s.backHome}>← Back to programs</Link>
        </div>
      </article>
    </div>
  );
}
